import axios from "axios";
import store from "@/store";
import router from "@/router";
import { configAutoLogout } from "@/services/security/authService";
export function setUpResponseInterceptors() {
    axios.interceptors.response.use(
        function success(response: any) {
            jwtHandler(response.headers.jwttoken);
            return response;
        },
        function error(error: any) {
            unAuthorizedHandler(error);
            return Promise.reject(error);
        }
    );
}
// interceptor handlers
function jwtHandler(token: any) {
    if (!token) return;
    store.commit("authentication/updateToken", token);
    configAutoLogout();
}
function unAuthorizedHandler(error: any) {
    if (!error.request ||
        error.response.status !== 401) return;
    if (!error.config ||
        error.config.__isRetryRequest) return;
    store.commit("authentication/authClear");
    router.push("/login");
}
